var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.79 75.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.84,3.94,56.59,2.65,49.91,39.46l7.75,1.21,5.15-27.16c17.12,6.23,26,16.23,24.73,22.92-.79,4.15-5.45,7.68-12.79,9.67a58.14,58.14,0,0,1-18.43,1.59L52,47.27l-3.76-.49c-1.24-.2-2.48-.43-3.73-.69C21.13,41.22,6.64,28.39,8.25,19.91c1.83-9.64,21.66-13.16,39-10.4L48.5,1.1C23.22-2.91,2.94,4.3.29,18.25c-1.44,7.59,2.58,15.58,11.34,22.51,7.93,6.26,19,11.12,31.28,13.67,1.24.26,2.48.49,3.72.7l-3.87,20.4H51L54.73,56.1A66.91,66.91,0,0,0,76.8,54.33c10.62-2.89,17.26-8.66,18.7-16.25C98,24.93,83.75,10.89,60.84,3.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.0356bb7d157a1c553cf3b7627258f434.svg";
export { ForwardRef as ReactComponent };